/* eslint-disable no-underscore-dangle */
import * as types from "../consts";
import { AuthFirebaseTokenAction } from "../interfaces";

const initState = {
  authFirebaseTokenResponse: {},
  isAuthFirebaseToken: null,
};

export default function authFirebaseTokenReducer(
  state = initState,
  action: AuthFirebaseTokenAction
) {
  switch (action.type) {
    case types.AUTH_FIREBASE_TOKEN_SUCCESS: {
      return {
        ...state,
        isAuthFirebaseToken: true,
        authFirebaseTokenResponse: action.response,
      };
    }

    case types.AUTH_FIREBASE_TOKEN_ERROR: {
      const status = 500;
      return { ...state, status: status, isAuthFirebaseToken: false };
    }

    case types.AUTH_FIREBASE_TOKEN_REQUEST: {
      return { ...state };
    }

    default: {
      return { ...state };
    }
  }
}
